<template>
  <div class="shopify-login">
    <div class="shopify-login-box">
      <form class="shopify-form" @submit.prevent="shopifySignIn(shopifyShop)">
        <h3>{{ $t('message.shopifyLogin.title') }}</h3>
        <div class="shop-input-container">
          <input class="shop-input" type="text" name="shop" id="shop" v-model="shopifyShop" :disabled="env === 'development'" placeholder="Shop name">
          <span class="shop-input-label"> .myshopify.com </span>
        </div>
        <button class="gm-button red" >{{ $t('message.shopifyLogin.button') }}</button>
      </form>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'shopify-login',
  data () {
    return {
      shopifyShop: process.env.VUE_APP_ENV === 'development' ? process.env.VUE_APP_SHOPIFY_STORE : '',
      env: process.env.VUE_APP_ENV
    }
  },
  methods: {
    handleLoginError (error) {
      alert(error.message)
    },
    shopifySignIn (shopName) {
      const shop = shopName + '.myshopify.com'
      if (process.env.VUE_APP_ENV === 'development') {
        firebase.auth().signInAnonymously()
      } else {
        window.location.href = 'install.html?shop=' + shop
      }
    }
  }
}
</script>

<style lang="scss">
/* "scoped" attribute limit the CSS to this component only */
.shopify-login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  &-box {
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 510px;
    /* height: 400px; */
    border-radius: 12px;
    box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.15);
    background-color: #2a2a36;
    .shopify-form {
      display: flex;
      justify-content: space-between;
      margin: 60px 72px;
      // align-items: center;
      flex-direction: column;
      height: 100%;
      font-family: Geomanist;
      h3 {
        width: 282px;
        height: 26px;
        // margin-bottom: 33px;
        font-size: 22px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.18;
        letter-spacing: normal;
        color: #f4f2f8;
      }
      .shop-input-container {
        font-weight: bold;
        color: white;
        .shop-input {
          margin: 12px 0;
          height: 56px;
          color: white;
          font-family: Geomanist;
          font-size: 16px;
          width: 200px;
          border-radius: 3px;
          background-color: #30303c;
          border: none;
        }
      }
      button {
        margin-top: 48px
      }
    }
  }
}
</style>
